export const ORGANISATION_LIST_QUERY_KEY = ["organisations"];
export const ORGANISATION_FACETS_QUERY_KEY = ["organisation-facets"];

export const BRAND_ME_SEARCH_QUERY_KEY = (brandOrganisationId: string) =>
  ["brand-me-search", brandOrganisationId] as const;

export enum BILLING_TYPE {
  Multiple = "Multiple",
  Single = "Single",
}

export const ORGANISATION_BRANDS_QUERY_KEY = ["organisation-brands"] as const;

export const BRAND_BILLING_QUERY_KEY = ["brand-billing-by-id"] as const;
